window.__Zone_ignore_on_properties = [];

const idbTargets = [
    IDBIndex,
    IDBRequest,
    IDBOpenDBRequest,
    IDBDatabase,
    IDBTransaction,
    IDBCursor,
];

idbTargets.forEach((target) => {
    window.__Zone_ignore_on_properties.push({
        target,
        ignoreProperties: [
            'upgradeneeded',
            'complete',
            'abort',
            'success',
            'error',
            'blocked',
            'versionchange',
            'close',
        ],
    });
});

window.__Zone_ignore_on_properties.push({
    target: WebSocket,
    ignoreProperties: ['close', 'error', 'open', 'message'],
});
